import IconDollarGradient, {
	IconDollarGradientProps as _IconDollarGradientProps,
} from './IconDollarGradient';

export { IconDollarGradient };
export type IconDollarGradientProps = _IconDollarGradientProps;
